const locale = process.env.REACT_APP_LOCALE ? process.env.REACT_APP_LOCALE :  'en';

export const API_VERSION = 'v2';
export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN ? process.env.REACT_APP_API_DOMAIN : process.env.REACT_APP_NODE_ENV === 'production' ? `https://app.birdietime.com` :  process.env.REACT_APP_NODE_ENV !== undefined ? (process.env.REACT_APP_NODE_ENV === 'ie' ? `https://admin.birdietime.com` : `https://app-${process.env.REACT_APP_NODE_ENV}.birdietime.com`) : `https://app-test.birdietime.com`;

export const API_ROOT = `${API_DOMAIN}/${locale}/api-public/${API_VERSION}/`;
export const API_ROOT_BARE = `${API_DOMAIN}/${locale}/api-public`;
export const API_SEARCH_ROOT = `${API_DOMAIN}/${locale}/api-public/v3`;

export const LESSON_API_DOMAIN =  process.env.REACT_APP_LESSON_API_DOMAIN ? process.env.REACT_APP_LESSON_API_DOMAIN : ['production', 'ie'].includes(process.env.REACT_APP_NODE_ENV) ? 'https://birdietime-setster-bridge.herokuapp.com' : 'https://birdietime-cal-bridge-staging.herokuapp.com';
export const LESSON_API_ROOT = ['production', 'ie'].includes(process.env.REACT_APP_NODE_ENV) ? `${LESSON_API_DOMAIN}/api/v2` : `${LESSON_API_DOMAIN}/api/v2`;

export const VOUCHER_API_DOMAIN = ['production', 'ie'].includes(process.env.REACT_APP_NODE_ENV) ? 'https://birdietime-vouchers.herokuapp.com' : 'https://birdietime-vouchers-test.herokuapp.com';
export const VOUCHER_STRIPE_HANDLE = `${VOUCHER_API_DOMAIN}/api/stripe/handle/`;





// WEBPACK FOOTER //
// ./src/api/constants.js